<opac-button [opac-go-back]="['/user/lists']" type="text">
  <opac-icon icon="navigate_back" slot="start"></opac-icon>
  {{ 'common.back' | translate }}
</opac-button>

<div class="header">
  <h1>{{ 'user.lists.authors' | translate }}</h1>
  <opac-button [opac-menu-trigger]="authorsActionsMenu"
               [ariaLabel]="'lists.moreActions' | translate" [opacTooltip]="'lists.moreActions' | translate"
  >
    <opac-icon icon="more_vertical" slot="only-icon"></opac-icon>
  </opac-button>
</div>

<opac-menu #authorsActionsMenu>
  <opac-menu-item (selected)="addAuthors()">
    <opac-icon icon="add"></opac-icon>
    {{ 'lists.addAuthors' | translate }}
  </opac-menu-item>

  <opac-menu-item *ngIf="userService.followedAuthors?.length > 0" (selected)="showUnfollowedAuthorsDialog.set(true)">
    <opac-icon icon="unfollow"></opac-icon>
    {{ 'lists.unfollowAll' | translate }}
  </opac-menu-item>
</opac-menu>

<span class="header-subtitle">
  {{ userService.followedAuthors?.length }}
  {{ (userService.followedAuthors?.length === 1 ? 'common.item' : 'common.items') | translate }}
</span>

<opac-divider></opac-divider>

<opac-no-results-cta *ngIf="userService.followedAuthors?.length === 0">
  {{ 'user.list.authors.follow' | translate }}
  <opac-button type="secondary" (click)="addAuthors()"> {{ 'user.list.authors.add' | translate}} </opac-button>
</opac-no-results-cta>

<div class="grid">
  <opac-author-card-item
    *ngFor="let author of userService.followedAuthors; let i = index"
    [backgroundColor]="author.color"
    [backgroundVectorImageIndex]="i"
    [name]="author.author"
    (click)="goToAuthor(author)"
  >
    <opac-button [ariaLabel]="'common.viewMore' | translate " [opacTooltip]="'common.viewMore' | translate" [opac-menu-trigger]="authorActionsMenu" (click)="selectAuthor($event, author)">
      <opac-icon slot="only-icon" icon="more_vertical"></opac-icon>
    </opac-button>
  </opac-author-card-item>
</div>

<opac-menu #authorActionsMenu>
  <opac-menu-item (selected)="unfollowAuthor()">
    <opac-icon icon="unfollow"></opac-icon>
    {{ 'lists.unfollow' | translate }}
  </opac-menu-item>
</opac-menu>

<opac-confirmation-dialog
  [acceptLabel]="'common.confirm'"
  [cancelLabel]="'common.cancel'"
  [open]="showUnfollowedAuthorsDialog()"
  [title]="'lists.unfollowAll' | translate"
  (accept)="unfollowAll()"
  (cancel)="showUnfollowedAuthorsDialog.set(false)">
  <p>{{ 'lists.unfollowAllAuthors' | translate }}</p>
</opac-confirmation-dialog>